module.exports = __webpack_public_path__ + "img/subBanner5.05da6787.png";